import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation, Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoImg from "../../../assets/icons/logo.svg";
import PharmacyLoginImg from "../../../components/IconComp/pharmacyloginImg.svg";
import {
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
  forgetPassword,
  forgetPasswordOtp,
  login,
  resetPassword,
} from "../../../features/auth/authSlice";
import { DASHBOARD_SCREEN_ROUTE, SIGNUP_SCREEN_ROUTE, START_SCREEN_ROUTE } from "../../../routes";
import AppButton from "../../common/AppButton";
import AppErrorMessage from "../../common/AppErrorMessage";
import LoadingSpinner from "../../common/Loading";
import EyeIcon from "../../IconComp/eye";
import EyeVisibleIcon from "../../IconComp/eyeVisible";
import ResetPassword from "./resetPassword";
import OtpScreenLogin from "./otpScreenLogin";
import LoginForgetPassword from "./loginForgetPassword";
import FreeTrialModal from "../../packages/freeTrialModel";
import SubscriptionConfirmModal from "../../packages/subscriptionConfirmModel";
import AppSnackbar from "../../common/AppSnackbar";

const formData = {
  email: "",
  phone_number: "",
  password: "",
};
const formDataForgetPassword = {
  email: "",
  phone_number: "",
};
const formDataResetPassword = {
  password: "",
  confirmPassword: "",
};
const LoginForm = () => {
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const { isLoading, isLoginError, loginMessage } = useAppSelector(
    (state: any) => state?.auth
  );
  const dispatch = useAppDispatch();
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isOtpScreen, setIsOtpScreen] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [value, setValue] = useState<any>(formData);
  const [forgetPassValue, setforgetPassValue] = useState(
    formDataForgetPassword
  );
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [resetPassValue, setResetPassValue] = useState(formDataResetPassword);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState(formData);
  const [otpError, setOtpError] = useState<any>("");
  const [forgetError, setForgetError] = useState<any>("");
  const [emailOtp, setEmailOtp] = useState<string>("");

  const [userType, setUserType] = useState("admin"); // Default to 'staff'
  const [id, setId] = useState<string>("");
  const [accType, setAccType] = useState<number>(0);
  let location = useLocation();
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev: any) => !prev);
  };
  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev: any) => !prev);
  };
  const handleForgotPassword = () => {
    setIsForgotPassword(true);
  };
  const [modalOpenFree, setModalOpenFree] = useState(false);
  const handleModalOpenFree = () => {
    setModalOpenFree(true);
  };

  const handleModalCloseFree = () => {
    setModalOpenFree(false);
    localStorage.removeItem("subscription_type");
  };

  // useEffect(() => {
  //   const subscriptionType = localStorage.getItem("subscription_type");
  //   if (
  //     subscriptionType === "2" ||
  //     subscriptionType === "3" ||
  //     subscriptionType === "4"
  //   ) {
  //     handleModalOpenFree(); // Automatically open the modal if subscription_type
  //   }
  // }, []);

  const getOtpAsString = () => otp.join("");

  const handleResetPassword = (otpString: string) => {
    const obj: any = {
      email: emailOtp || null, // Use email if provided
      // phone_number: phone || null, // Use phone_number if provided
      otp: otpString,
    };
    dispatch(forgetPasswordOtp(obj))?.then((res) => {
      if (res?.payload?.success === true) {
        setId(res?.payload?.data?.id);
        setIsResetPassword(true);
      } else {
        setOtpError(res?.payload);
      }
    });
  };

  const handleSubmit = () => {
    // Validate fields
    if (!value.email && !value.phone_number) {
      setErrors((prev) => ({
        ...prev,
        email: "Email or Phone number is required",
        phone_number: "Email or Phone number is required",
      }));
      return;
    }
    if (!value.password) {
      setErrors((prev) => ({
        ...prev,
        password: "Password is required",
      }));
      return;
    }
    let accountType = null;
    // Set type in local storage based on userType
    if (userType === "admin") {
      accountType = 0;
      localStorage.setItem("pharmacy_account_type", "0");
    } else if (userType === "staff") {
      accountType = 1;
      localStorage.setItem("pharmacy_account_type", "1");
    }

    // Determine the type of input (email or phone_number)
    let email = null;
    let phone_number = null;

    if (value.email && /^\d+$/.test(value.email)) {
      // If the value in email field is numeric, treat it as phone_number
      phone_number = value.email;
    } else if (value.email) {
      // Otherwise, treat it as an email
      email = value.email;
    }

    const obj: any = {
      email: email || null, // Use email if provided
      phone_number: phone_number || value?.phone_number || null, // Use phone_number if provided
      password: value?.password,
      account_type: accType,
    };
    dispatch(login(obj))?.then((res) => {
      if (res?.payload?.success === true) {
        localStorage?.setItem(
          "pharmacyAuthToken",
          JSON?.stringify(res?.payload?.data?.token)
        );
        localStorage?.setItem("pharmacyId", res?.payload?.data?.pharmacy_id);
        navigate(DASHBOARD_SCREEN_ROUTE);
      } else {
        // Handle the case where login fails (e.g., show error messages)
        console.error(
          "Login failed:",
          res?.payload?.message || "Unknown error"
        );
      }
    });
  };

  const isMobile = useMediaQuery("(max-width: 1022px)");
  const handleContinue = (prop: any) => {
    // Validate fields
    if (!forgetPassValue.email && !forgetPassValue.phone_number) {
      setErrors((prev) => ({
        ...prev,
        email: "Email or Phone number is required",
        phone_number: "Email or Phone number is required",
      }));
      return;
    }

    // Determine the type of input (email or phone_number)
    let email = null;
    let phone_number = null;

    if (forgetPassValue.email && /^\d+$/.test(forgetPassValue.email)) {
      // If the forgetPassValue in email field is numeric, treat it as phone_number
      phone_number = forgetPassValue.email;
    } else if (forgetPassValue.email) {
      // Otherwise, treat it as an email
      email = forgetPassValue.email;
    }

    const obj: any = {
      email: email || null, // Use email if provided
      phone_number: phone_number || null, // Use phone_number if provided
    };

    dispatch(forgetPassword(obj))?.then((res) => {
      if (res?.payload?.success === true) {
        setEmailOtp(res?.payload?.data?.email);
        setIsOtpScreen(true);
      } else {
        setForgetError(res?.payload);
      }
    });
  };

  const handlePasswordSubmit = (prop: any) => {
    // Validate fields
    if (!resetPassValue.password) {
      setErrors((prev) => ({
        ...prev,
        password: "Required*",
      }));
      return;
    }

    // Password complexity check: at least 6 characters,one number, and one character

    const passwordPattern = /^(?=.*[0-9])(?=.*[^\d]).{6,}$/;
    if (!passwordPattern.test(resetPassValue.password)) {
      setErrors((prev) => ({
        ...prev,
        password:
          "Password must be at least 6 characters long and include at least one number and one character.",
      }));
      return;
    }

    if (!resetPassValue.confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: "Confirm password is required.",
      }));
      return;
    }
    if (resetPassValue.password !== resetPassValue.confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: "Passwords must match.",
      }));
      return;
    }
    const obj: any = {
      id: id,
      password: resetPassValue.password, // Use phone_number if provided
      account_type: accType,
    };

    dispatch(resetPassword(obj))?.then((res) => {
      if (res?.payload?.success === true) {
        setIsResetPassword(false);
        setIsOtpScreen(false);
        setIsForgotPassword(false);
        setOpenSnackbar(true);
      } else {
        alert(res?.payload);
      }
    });
  };
  const handleChange = (value: string, index: number) => {
    if (/^\d?$/.test(value)) {
      // Allow only numeric input
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to the next box if value is entered
      if (value && index < otp?.length - 1) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (!otp[index] && index > 0) {
        // Move focus to the previous box if empty and Backspace is pressed
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) prevInput.focus();
        newOtp[index - 1] = "";
      } else {
        newOtp[index] = "";
      }
      setOtp(newOtp);
    }
  };
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    // Logic for "email" or "phone_number" distinction
    if (name === "email_or_phone") {
      if (isNaN(value)) {
        // Treat input as email
        setErrors((prev) => ({ ...prev, email: "" }));
        setValue((prev: any) => ({ ...prev, email: value, phone_number: "" }));
      } else if (/^\d+$/.test(value)) {
        // Treat input as phone number
        setErrors((prev) => ({ ...prev, phone_number: "" }));
        setValue((prev: any) => ({ ...prev, phone_number: value, email: "" }));
      }
    } else {
      // General case for other fields
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setValue((prev: any) => ({ ...prev, [name]: value }));
    }
  };
  const handleInputChangeForget = (e: any) => {
    const { name, value } = e.target;

    // Logic for "email" or "phone_number" distinction
    if (name === "email_or_phone") {
      if (isNaN(value)) {
        // Treat input as email
        setErrors((prev) => ({ ...prev, email: "" }));
        setforgetPassValue((prev: any) => ({
          ...prev,
          email: value,
          phone_number: "",
        }));
      } else {
        // Treat input as phone number
        setErrors((prev) => ({ ...prev, phone_number: "" }));
        setforgetPassValue((prev: any) => ({
          ...prev,
          phone_number: value,
          email: "",
        }));
      }
    } else {
      // General case for other fields
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setforgetPassValue((prev: any) => ({ ...prev, [name]: value }));
    }
  };
  const handleInputChangeResetPass = (e: any) => {
    const { name, value } = e.target;
    // Reset the error for the field being modified
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setResetPassValue((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleNavigation = () => {
    const currentPath = window.location.pathname.replace("/pms", "");
    const targetPath = "/products/pharmacymanagement?packages=true";

    window.location.href = currentPath === "" ? targetPath : targetPath;
  };

  const handleKeyboard = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default action for Enter key
      handleSubmit(); // Trigger the submit function
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        backgroundColor: "#fff",
      }}
    >
      {/* Left Section - Form */}
      <Box
        component="img"
        src={PharmacyLoginImg}
        alt="login_img"
        sx={{
          width: "100%", // Default for smaller screens
          "@media (min-width: 1024px) and (max-width: 1400px)": {
            width: "55%", // Adjusted width for screens between 1024px and 1400px
          },
          "@media (min-width: 1400px) and (max-width: 1600px)": {
            width: "65%", // Adjusted width for screens larger than 1400px
          },
          "@media (min-width: 1600px) ": {
            width: "70%", // Adjusted width for screens larger than 1400px
          },
          p: isMobile ? 2 : 6,
          height: isMobile ? "0" : "100vh",
          backgroundImage: "linear-gradient(180deg, #0196DA 0%, #025BAB 100%)",
        }}
      />

      {/* Right Section - Illustration */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          //justifyContent: "center",
          //alignItems: "center",
          padding: 4,
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            pt: 7,
          }}
        >
          <Box
            component="img"
            src={LogoImg}
            alt="logo"
            sx={{ width: "142px", cursor: "pointer" }}
            onClick={() => navigate(START_SCREEN_ROUTE)}
          />
          <Box sx={{ fontSize: "18px", pt: 1, mb: "88px" }}>
            Pharmacy Management System
          </Box>
        </Box>

        {isResetPassword ? (
          <ResetPassword
            handlePasswordSubmit={handlePasswordSubmit}
            handleInputChangeResetPass={handleInputChangeResetPass}
            handleTogglePasswordVisibility={handleTogglePasswordVisibility}
            handleToggleConfirmPasswordVisibility={
              handleToggleConfirmPasswordVisibility
            }
            resetPassValue={resetPassValue}
            showPassword={showPassword}
            showConfirmPassword={showConfirmPassword}
            errors={errors}
          />
        ) : isOtpScreen ? (
          <OtpScreenLogin
            handleResetPassword={handleResetPassword}
            handleChange={handleChange}
            handleKeyDown={handleKeyDown}
            value={value}
            otp={otp}
            getOtpAsString={getOtpAsString}
            handleContinue={handleContinue}
            otpError={otpError}
          />
        ) : isForgotPassword ? (
          <LoginForgetPassword
            handleContinue={handleContinue}
            handleInputChangeForget={handleInputChangeForget}
            forgetPassValue={forgetPassValue}
            errors={errors}
            forgetError={forgetError}
          />
        ) : (
          <>
            <Grid
              container
              spacing={2}
              style={{
                paddingLeft: isMobile ? "0px" : "30px",
                paddingRight: isMobile ? "0px" : "30px",
              }}
            >
              {/* User Type Selection */}
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    value={userType}
                    // onChange={(e) => setUserType(e.target.value)}
                    onChange={(e) => {
                      const selectedUserType = e.target.value;
                      setUserType(selectedUserType);

                      // Set the type based on selected userType
                      if (selectedUserType === "admin") {
                        localStorage.setItem("type", "0");
                        setAccType(0); // Set accType state for form submission
                      } else if (selectedUserType === "staff") {
                        localStorage.setItem("type", "1");
                        setAccType(1); // Set accType state for form submission
                      }
                    }}
                  >
                    <FormControlLabel
                      value="admin"
                      control={
                        <Radio
                          sx={{
                            color: "#DDDDDD",
                            //color: "#0055A8", // Blue color for unselected radio button
                            "&.Mui-checked": {
                              color: "#0055A8", // Blue color for selected radio button
                            },
                          }}
                        />
                      }
                      label="Owner / Admin"
                    />
                    <FormControlLabel
                      value="staff"
                      control={
                        <Radio
                          sx={{
                            color: "#DDDDDD",
                            //color: "#0055A8", // Blue color for unselected radio button
                            "&.Mui-checked": {
                              color: "#0055A8", // Blue color for selected radio button
                            },
                          }}
                        />
                      }
                      label="Staff"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {/* Email / Phone Number Field */}
              <Grid item xs={12}>
                <TextField
                  label="Mobile Number or Email"
                  name="email"
                  value={value.email || value.phone_number}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyboard}
                  error={Boolean(errors.email)}
                  helperText={errors.email}
                  placeholder="e.g.+923xxxxxxxxx or ex@gmail.com"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "40px", // Set the total height of the input field
                      padding: "0", // Remove default padding
                      display: "flex",
                      alignItems: "center", // Center the input content
                      justifyContent: "center",
                    },
                    "& .MuiFormLabel-root": {
                      top: "-5px", // Adjust label positioning if necessary
                    },
                    "& .MuiInputBase-input": {
                      padding: "0 10px", // Add inner padding for input
                      height: "100%", // Fill the container's height
                      boxSizing: "border-box",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="password"
                  label="Password"
                  value={value.password}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyboard}
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <EyeVisibleIcon /> : <EyeIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "40px", // Set the total height of the input field
                      padding: "0", // Remove default padding
                      display: "flex",
                      alignItems: "center", // Center the input content
                      justifyContent: "center",
                      paddingRight: "15px",
                    },
                    "& .MuiFormLabel-root": {
                      top: "-5px", // Adjust label positioning if necessary
                    },
                    "& .MuiInputBase-input": {
                      padding: "0 10px", // Add inner padding for input
                      height: "100%", // Fill the container's height
                      boxSizing: "border-box",
                    },
                  }}
                  error={Boolean(errors.password)}
                  helperText={errors.password}
                />
              </Grid>
              {isLoginError && (
                <Grid item xs={12}>
                  <AppErrorMessage message={loginMessage} />
                </Grid>
              )}
              <Grid item xs={12}>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <AppButton
                    title="Login"
                    fullWidth
                    variant="contained"
                    sx={{ mb: 2 }}
                    onClick={handleSubmit}
                  />
                )}
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end">
              <Box
                sx={{
                  pb: 2,
                  cursor: "pointer",
                  color: "#635C5C",
                  fontSize: "14px",
                  fontWeight: 500,
                  px: isMobile ? 0 : 4,
                }}
                onClick={handleForgotPassword}
              >
                Forgot Password ?
              </Box>
            </Grid>
          </>
        )}
        {isOtpScreen ? null : (
          <Grid container justifyContent="center">
            <Box sx={{ pb: 2, fontSize: "16px", fontWeight: 400 }}>
              Don't have an account yet?{" "}
              {/* <span
                onClick={handleNavigation}
                style={{
                  color: "#0055A8",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Signup
              </span> */}
              <Link
                to={SIGNUP_SCREEN_ROUTE}
                //state={{ state: "clinic_owner" }}
              >
                <span
                  style={{
                    color: "#0055A8",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                >
                  Signup
                </span>
              </Link>
            </Box>
          </Grid>
        )}
        <SubscriptionConfirmModal
          open={modalOpenFree}
          onClose={handleModalCloseFree}
        />
      </Container>
      <AppSnackbar
        message="Password Update Successfully!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </Box>
  );
};

export default LoginForm;
